// ---------------------------------------------------------------------------------------------------------------------
// Utilities function for gender redirection
// ---------------------------------------------------------------------------------------------------------------------

const setCookie = (cookie_name, cookie_value, expiration_days) => {
    const d = new Date();
    d.setTime(d.getTime() + (expiration_days*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cookie_name + "=" + cookie_value + ";" + expires + ";path=/";
}

const getCookie = (cookie_name) => {
    let name = cookie_name + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// ---------------------------------------------------------------------------------------------------------------------
// Redirections
// ---------------------------------------------------------------------------------------------------------------------
const isPreHome = location.pathname === '/';
let cookieHomeType = getCookie('home_type');

console.log('Gender is ' + cookieHomeType);


if (isPreHome) {
  if (cookieHomeType && !Shopify.designMode) {
    document.body.style.display = "none";
    window.location.replace(cookieHomeType);
    window.history.replaceState(null, null, cookieHomeType);
  }
}

document.addEventListener('DOMContentLoaded', () => {
    const currentPageHomeInput = document.querySelector('.js-current-gender-type');
    const currentPageHomeType = currentPageHomeInput.value;
    const pageTypeNeutral = currentPageHomeType === ''

    // then if user is navigating, init and update gender cookie
    if (!cookieHomeType) {
      // create cookie for the first time
      // console.log('Création du cookie avec pour valeur ' + currentPageHomeType);
      setCookie('home_type', currentPageHomeType, 365)
    // update cookie if gender is different
    } else if (cookieHomeType && currentPageHomeType && cookieHomeType !== currentPageHomeType) {
        // console.log('Mise à jour du cookie avec pour valeur ' + currentPageHomeType);
        setCookie('home_type', currentPageHomeType, 365)
    }

    // finally, use this cookie to fill informations for gender neutral pages (blog, faq, CMS...)
    if (pageTypeNeutral) {
      // console.log('La page est neutre, on utilise la valeur du cookie ' + cookieHomeType);

      if (!cookieHomeType) {
        cookieHomeType = '/pages/femme'
      }

      // fill link on header
      let headerLink = document.querySelector('.js-gender-neutral-link');
      if (headerLink) {
        headerLink.href = cookieHomeType;
      }

      // set actives categories on header
      let navigationDrawer = document.querySelector('.js-gender-neutral-navigation');
      if (navigationDrawer) {
        const navigationItems = navigationDrawer.querySelectorAll(`[data-gender="${cookieHomeType}"]`)
        for (let i = 0; i < navigationItems.length; i++) {
          let navigationItem = navigationItems[i];
          navigationItem.classList.add('active');
        }
      }
    }
});

